
import { faqMenu } from '../_mock/faq_menu'
import { seo } from '../customWhiteLabel.js'
export default {
  data() {
    return {
      seo,
      activeAccordion: {
        sectionIndex: null,
        itemIndex: null,
      },
      activeNavSection: null,
      sections: faqMenu,
    }
  },
  methods: {
    mounted() {
      window.addEventListener('scroll', this.onScroll)
    },

    beforeDestroy() {
      window.removeEventListener('scroll', this.onScroll)
    },

    toggleAccordion(sectionIndex, itemIndex) {
      if (
        this.activeAccordion.sectionIndex === sectionIndex &&
        this.activeAccordion.itemIndex === itemIndex
      ) {
        this.activeAccordion = { sectionIndex: null, itemIndex: null } // Fechar
      } else {
        this.activeAccordion = { sectionIndex, itemIndex } // Abrir o selecionado
      }
    },

    isOpen(sectionIndex, itemIndex) {
      return (
        this.activeAccordion.sectionIndex === sectionIndex &&
        this.activeAccordion.itemIndex === itemIndex
      )
    },

    onScroll() {
      this.sections.forEach((section, index) => {
        const sectionId = section.url_router
        const element = document.getElementById(sectionId)
        if (element) {
          const rect = element.getBoundingClientRect()
          if (rect.top >= 0 && rect.top < window.innerHeight / 2) {
            this.activeNavSection = index
          }
        }
      })
    },

    getNavIconClass(sectionIndex) {
      return this.activeNavSection === sectionIndex
        ? 'mdi mdi-chevron-down'
        : 'mdi mdi-chevron-right'
    },

    scrollToSection(paramsRoute, index) {
      const element = document.getElementById(paramsRoute)
      if (element) {
        const offset = 100
        const elementPosition = element.getBoundingClientRect().top
        const offsetPosition = elementPosition + window.scrollY - offset

        window.scrollTo({
          top: offsetPosition,
          behavior: 'smooth',
        })

        history.pushState(null, '', `#${paramsRoute}`)

        this.activeNavSection = index
      }
    },
  },
}
